export default __webpack_public_path__ + "images/ae131996b6930fc55afe7d9f06f87ad4.svg";